import axios, { AxiosStatic } from 'axios';
import { setupCache, type AxiosCacheInstance } from 'axios-cache-interceptor';

setupCache(axios);

export default axios as AxiosCacheInstance & AxiosStatic;